import * as Request from './util/request';
import loadScript from './util/loadscript';
import loadCSS from './util/loadcss';
window.$ACE_LOADER = async () => {
  if (window.$ACE) {
    return window.$ACE;
  }
  const responsive = await Request.getQuery('aliyun-config.ace-services-common-verison');
  const version = responsive.version;
  loadCSS(`//g.alicdn.com/??aliyun/util/${version}/css/index.css`);
  await loadScript(`//g.alicdn.com/??aliyun/util/${version}/index.js`);
  return window.$ACE;
};



// WEBPACK FOOTER //
// ./src/loader.js